import { useDispatch } from "react-redux";
import { setBreadCrumbsData } from "../../../store/redux/breadCrumbsData";
import { useTranslation } from "react-i18next";
import CreatePageForm from "../../../modules/pages/components/CreatePageForm";

const CreatePage = () => {
    const {t}=useTranslation()
    const dispatch=useDispatch()
    dispatch(setBreadCrumbsData({
        links: [{label: t("create_page"),path:"/pages/create-page"}],
		page_title: t("create_page"),
    }))

    return (
        <div>
            <CreatePageForm />
        </div>
    );
}

export default CreatePage;